import React, { createContext, useContext, useState, ReactNode } from 'react';
import { ThemeManager, SUPPORTED_THEMES } from '../config/themes';
import { useTheme } from '../config/themes';
import type { ThemeContextType } from '../types';

const ThemeContext = createContext<ThemeContextType>({
  theme: 'light',
  changeTheme: () => {},
  getClass: (type: string) => '',
  getColor: (type: string) => '',
  config: {},
  SUPPORTED_THEMES,
});

interface ThemeProviderProps {
  children: ReactNode;
}

export const ThemeProvider: React.FC<ThemeProviderProps> = ({ children }) => {
  const [theme, setTheme] = useState<string>(ThemeManager.getCurrentTheme());

  const changeTheme = (id: string): void => {
    if (ThemeManager.setTheme(id)) {
      setTheme(id);
    }
  };

  const themeData = useTheme(theme as any);

  const value: ThemeContextType = {
    theme,
    changeTheme,
    getClass: themeData.getClass,
    getColor: themeData.getColor,
    config: themeData.config,
    SUPPORTED_THEMES,
  };

  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useThemeContext = (): ThemeContextType => useContext(ThemeContext); 